import {type AppState} from '../../types/app-state'
import {type LocationIdType} from '../locations/state'
import {displayErrorMessage, getTheErrorCodes} from './helper'
import {
    type VesselTag,
    type CreateVesselTagReq,
    type AssignVesselToTagReq,
    type UpdateVesselTagReq,
} from '../../../api/vessels/vessel-tags'
import {type LocationTagArrayMapType} from './state'

export const vesselTagsSelector = (state: AppState): VesselTag[] => state.vesselTags.vesselTags

export const vesselTagsForLocationsSelector = (state: AppState): LocationTagArrayMapType =>
    state.vesselTags.tagsForLocation

export const isTheMessageErrorSelector = (state: AppState): boolean =>
    getTheErrorCodes(state.vesselTags.errorResult)

export const errorMessageSelector = (state: AppState): string =>
    displayErrorMessage(state.vesselTags.errorResult)

export const displayVesselSettingsSelector = (state: AppState): LocationIdType | undefined =>
    state.vesselTags.displayVesselSettingsForId

export const tagToCreateOrAssignSelector = (
    state: AppState,
): CreateVesselTagReq | AssignVesselToTagReq | null => state.vesselTags.tagToCreateOrAssign

export const tagToUpdateSelector = (state: AppState): UpdateVesselTagReq | null =>
    state.vesselTags.tagToUpdate

export const searchTermSelector = (state: AppState): string => state.vesselTags.searchedTerm

export const isTagLoadingSelector = (state: AppState): boolean => state.vesselTags.isFetchingTags
